export default __webpack_public_path__ + "static/porterandsail-fe3047016494fa1e2e2a42985ed61029.png";